module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayrainshowers-e407f2089323e59d976e31cbfba7f585.svg";